/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import SegmentationEvent from '../../event/SegmentationEvent'
import { SegmentCategoryState } from '../state/SegmentCategoryState'
import { SegmentValueState } from '../state/SegmentValueState'

class SegmentCategoriesStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case SegmentationEvent.fetchAll:
        return List(
          payload.segment_categories.map(category => {
            const segmentCategory = new SegmentCategoryState(category)
            let segmentValues = []
            if (category.segment_values && category.segment_values.length > 0) {
              segmentValues = category.segment_values.map(value => value.name)
            }
            return segmentCategory.set('segmentValues', segmentValues)
          })
        )

      default:
        return state
    }
  }
}

export default new SegmentCategoriesStore()
